<template>
  <div class="apply">
    <Header title="免修申请"></Header>
    <div class="apply-body">
      <div>
        <p class="apply-title">{{this.topInfo.coursename}}</p>
        <p class="apply-num">学时：{{this.topInfo.period}}</p>
        <p class="apply-num">学分：{{this.topInfo.credit}}</p>
      </div>

      <div class="apply-inputs">
        <div class="apply-input">
          <p><span style="color:red" >*</span>申请原因</p>
          <input type="text" placeholder="请点击填写" v-model="reason"/>
        </div>

        <div class="apply-input">
          <p><span style="color:red" >*</span>免修方式</p>
          <input type="text" placeholder="请点击选择" v-model="checkMxfsdmmc" readonly @click="isMxfsShow()"/>
          <i class="arrow"></i>
        </div>


        <div class="apply-input" >
          <p v-if="this.schoolCode=='12561'"><span style="color:red">*</span>证明材料</p>
          <p v-else><span style="color:red">*</span>上传附件</p>
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            :max-size="10 * 1024 * 1024"
            @oversize="onOversize"
            :max-count="1"
          > <div class="fujianImg"></div></van-uploader>
        </div>


        <div class="apply-input">
          <p><span style="color:red" >*</span>审核人</p>
          <input type="text" placeholder="请点击选择" @click="isPopShow()" v-model="person" readonly/>
          <i class="arrow"></i>
        </div>
      </div>
    </div>
    <button class="apply-btn" @click="submitApply()">提交申请</button>

    <!-- 审核人popup -->
    <van-popup v-model="isShow" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="isShow = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button class="per-btn" ref="person" @click="personTap($event,index)" v-for="(item,index) in personList" :key="item.id">{{item.name}}</button>
        </div>
      </div>
    </van-popup>

    <!-- 免修方式popup -->
    <van-popup v-model="isShowmxfs" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="isShowmxfs = false"></i>
          <p>免修方式</p>
          <i class="confirm-icon" @click="mxfsEnter()"></i>
        </div>
        <div class="person">
          <button class="per-btn" ref="checkMxfsdm" @click="mxfsTap($event,index)" v-for="(item,index) in mxfsList" :key="item.dm">{{item.dmmc}}</button>
        </div>
      </div>
    </van-popup>
    <div class="noteisDiv" v-if="this.schoolCode=='12561'">
      注意事项：
      <div class="noteisDiv-context">
         证明材料需上传清晰有效。<br>
         证明材料为等级证书、退伍证、北京市二级及以上综合医院或专科医院出具的诊断证明（无诊断证明章无效）
      </div>
    </div>

  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  import freeApply from "../../newPages/teacher/internship/components/freeApply";
  export default{
    data(){
      return{
        isShow:false,
        fileList: [],
        file: {},
        topInfo:'',
        reason:'',
        personList:[],
        person:'',
        personId:'',
        reset:"",
        resetId:'',
        schoolCode: sessionStorage.getItem("schoolCode"),
        mxfsList:[],
          isShowmxfs:false,
          mxfsdm:'',
          mxfsdmmc:'',
         checkMxfsdm:"",
         checkMxfsdmmc:"",
          ywcode:''
      }
    },
    created(){
      this.topInfo = JSON.parse(this.$route.query.data);
        this.getMxfs();
      // this.getPeople()
    },
    methods:{
      resetCancel(){
        this.isShow= false
        this.person = this.reset
        this.personId = this.resetId
      },
      mxfsEnter(){
          this.isShowmxfs= false
          this.checkMxfsdm = this.mxfsdm
          this.checkMxfsdmmc = this.mxfsdmmc

          //获取送审人
          if(this.checkMxfsdm=="1"){
              this.ywcode="721";
          }
          if(this.checkMxfsdm=="2"){
              this.ywcode="722";
          }
          if(this.checkMxfsdm=="3"){
              this.ywcode="723";
          }
          if(this.checkMxfsdm=="4"){
              this.ywcode="724";
          }
          this.getPeople(this.ywcode)
          this.person = ""
          this.personId=""
      },
      onOversize(file) {
          this.$toast.fail("文件大小不能超过10M");
      },
      afterRead(file) {
          // 此时可以自行将文件上传至服务器
          this.file = file.file;
      },
      async getPeople(code){
        const params = {
          ywcode:code,
          ywid:this.topInfo.jx0404id
        }
        const res = await Api.selectReviewerApi(params)
        let concatList =[
        ];
        res.data.forEach((item,index) => {
          concatList[index] = {
            name:item.userrealname,
            id:item.userid,
            isBtn:0,
          }
        });
        this.personList = concatList
      },
      isPopShow(){
        if(this.checkMxfsdm==""||this.checkMxfsdm==null){
            this.$toast.fail('请选择免修方式')
            return false;
        }
          this.isShow = !this.isShow
      },
        isMxfsShow(){
        this.isShowmxfs = !this.isShowmxfs
      },
      close(){
        this.isShow =false
      },
      async submitApply(){
        if(this.reason == ''){
          this.$toast.fail('请填写申请原因~');
          return;
        }
        else if(this.checkMxfsdm==""){
            this.$toast.fail('请选择免修方式');
            return;
        }
        else if(this.fileList.length==0){
          if(this.schoolCode=='12561'){
            this.$toast.fail('请上传整明材料');
            return;
          }else{
            this.$toast.fail('请上传附件');
            return;
          }
            
        }
        else if(this.person==''){
            this.$toast.fail('请选择审核人');
            return;
        }
        else{

          const params = {
            cj0704id:this.topInfo.cj0704id,
            reason:this.reason,
            auditor:this.person == '全部' ? '' : this.personId,
              type:"save",
              mxfs:this.checkMxfsdm,
              ywcode:this.ywcode,
              mxsqfj:this.file,
              xnxq01id:this.topInfo.xnxq01id,
              coursename:this.topInfo.coursename
          }
          console.log(this.topInfo)
          const res = await Api.getExemptExam(params)
          this.$toast(res.Msg)
          if(res.code == '1'){
            this.$router.replace('/student/exemptExam');
          }
        }
      },
      personTap(e,res){
        let strList = []
        let idList = []
        
        if(this.personList[res].isBtn == 0){
          this.personList[res].isBtn = 1
          e.target.className = 'cur'
        }else if(this.personList[res].isBtn == 1){
          this.personList[res].isBtn = 0
          e.target.className = 'per-btn'
        }

        for(let i in this.personList){
          if(this.personList[i].isBtn == 1){
            strList = strList.concat(this.personList[i].name)
            idList = idList.concat(this.personList[i].id)
          }
        }
        this.reset = strList.toString();
        this.resetId = idList.toString();
      },
       getMxfs(){
           let themxfs= JSON.parse(this.$route.query.mxfs);
           let concatList = []
           themxfs.forEach((item,index) => {
               concatList[index] = {
                   dmmc:item.dmmc,
                   dm:item.dm,
                   isBtn:0,
               }
           });
           this.mxfsList = this.mxfsList.concat(concatList)
       } ,
        mxfsTap(e,res){
          if(this.mxfsList[res].isBtn == 0){
              this.mxfsList[res].isBtn = 1
              e.target.className = 'cur'
          }else if(this.mxfsList[res].isBtn == 1){
              this.mxfsList[res].isBtn = 0
              e.target.className = 'per-btn'
          }

          for(let i in this.mxfsList){
              if(i!=res){
                  this.mxfsList[i].isBtn = 0;
                  this.$refs.checkMxfsdm[i].className = 'per-btn'
              }
          }
          this.mxfsdm=this.mxfsList[res].dm;
          this.mxfsdmmc=this.mxfsList[res].dmmc;

        }
    }

  }
</script>

<style lang="less" scoped>
  .noteisDiv{
    padding-left: 20px;
    padding-right: 20px;
    .noteisDiv-context{
      padding-left: 10px;
      font-size: 13px;
    }
  }
  .fujianImg{
    background: url(../../../assets/images/fujian.png)no-repeat center;
    background-size: 18px 18px;width: 18px;height: 18px;
  }
  .van-cell--required::before{
    left:0px!important;
  }
  .scfj span{
    color:red!important;
    background-color: darkgreen;
    margin-left:-11px;
  }


  .apply-body{padding: 20px;}
  .apply-body .apply-title{font-size: 18px;color: @attendance-color-1;font-weight: 600;}
  .apply-body .apply-num{font-size: 14px;color: @attendance-color-2;margin-top: 8px;}
  .apply-inputs{margin-top: 17px;}
  .apply-inputs .apply-input{padding: 9px 0;display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid @attendance-border-color-6;color: @attendance-color-1;}
  .apply-input input{flex: 1;text-align: right;color: @attendance-color-1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;padding-left: 20px;}
  .apply-input input::placeholder{color: @attendance-background-color-2;font-size: 16px;}
  .apply .apply-btn{position: absolute;bottom: 20px;background-color: @attendance-background-color-1;padding: 11px 0;color: @attendance-color-3;border-radius: 3px;width: 90%;margin-left: 5%;}
  .apply-pop{
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    max-height: 40%;
    overflow-y: scroll;
  }
  .close-icon{background: url(../../../../static/img/close.png)no-repeat center;}
  .pop-title{display: flex;justify-content: space-between;
    padding: 13px;
    position: fixed;
    width: 100%;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;z-index: 9;}
  .pop-title i{width: 22px;height: 22px;background-size: 22px 22px;}
  .confirm-icon{background: url(../../../../static/img/confirm.png)no-repeat center;}
  .apply-pop .person{padding: 20px 20px 0;display: flex;flex-wrap: wrap;margin-top: 48px;}
  .person button{border-radius:3px;padding: 5px 15px;margin-right: 12px;margin-bottom: 15px;}
  .apply-pop .person .per-btn{background-color: @attendance-background-color-7;color: @attendance-background-color-1;}
  .person .cur{background-color: @attendance-background-color-1;color: @attendance-background-color-7;}
  .apply-input .arrow{background: url(../../../../static/img/arrow_r.png)no-repeat center;width: 13px;height: 13px;background-size: 13px 13px;margin-left: 10px;}
 
</style>



// WEBPACK FOOTER //
// src/components/student/exemptTest/exemptApply.vue